import { render } from "./FacilityConfigMenu.vue?vue&type=template&id=cc71e0c2&scoped=true"
import script from "./FacilityConfigMenu.vue?vue&type=script&lang=js"
export * from "./FacilityConfigMenu.vue?vue&type=script&lang=js"

import "./FacilityConfigMenu.vue?vue&type=style&index=0&id=cc71e0c2&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc71e0c2"]])

export default __exports__